import axios from 'axios';
import React, { memo, useEffect } from 'react';
import apiConfig from 'src/api/APIConfig';
import { useAppDispatch } from 'src/store/hooks';
import { setProgress } from 'src/store/Loader';
import { Gantt, Task } from '../../GanttChart';

const MilestoneGanttChart = ({ viewModeType, currentMonth, currentYear, currentMonthDate, search }: any) => {
  const dispatch = useAppDispatch();

  const makeTaskObj = (minorMilestones: any) => {
    let taskList: Task[] = [];
    const currentDate = new Date();
    minorMilestones.forEach((row: any) => {
      if (
        row.min_start_date != null &&
        row.min_start_date !== '' &&
        row.max_end_date != null &&
        row.max_end_date !== '' &&
        row.min_start_date <= row.max_end_date
      ) {
        if (
          (viewModeType == 'Month' &&
            currentYear >= new Date(row.min_start_date).getFullYear() &&
            currentYear <= new Date(row.max_end_date).getFullYear()) ||
          viewModeType == 'All' ||
          (currentYear >= new Date(row.min_start_date).getFullYear() &&
            currentYear <= new Date(row.max_end_date).getFullYear() &&
            viewModeType == 'Day' &&
            (currentMonth == new Date(row.min_start_date).getMonth() + 1 ||
              currentMonth == new Date(row.max_end_date).getMonth() + 1)) ||
          (Date.parse(currentMonthDate) <= Date.parse(row.max_end_date) &&
            Date.parse(currentMonthDate) >= Date.parse(row.min_start_date))
        ) {
          const t: Task = {
            start: new Date(row.min_start_date),
            end: new Date(row.max_end_date),
            name: row.minor_milestone_name,
            id: row.milestone_id,
            progress: Math.round(row.progress),
            type: 'task',
            project: row.milestone_reference,
            styles: { progressColor: '#ffbb54', progressSelectedColor: '#ff9e0d' }
          };
          taskList = [...taskList, t];
        }
      }
    });
    return taskList;
  };

  const [tasks, setTasks] = React.useState<Task[]>([]);
  const columnWidth = 70;

  const getMilestoneGanttViewData = async () => {
    dispatch(setProgress(true));
    try {
      const url = `${apiConfig.appConfig.apictms}/site/milestone/ganttChart/${search.Site}/${search.Study}/getAll?country=${search.Country}`;
      const response = await axios.get(url);
      if (search.Study !== '--' && search.Country !== '--' && search.Site !== '--') {
        const milestoneData = response.data;
        let taskList: Task[] = [];
        milestoneData.forEach((milestone: any) => {
          if (
            milestone.min_start_date != null &&
            milestone.min_start_date !== '' &&
            milestone.max_end_date != null &&
            milestone.max_end_date !== '' &&
            milestone.min_start_date <= milestone.max_end_date
          ) {
            if (
              (viewModeType == 'Month' &&
                currentYear >= new Date(milestone.min_start_date).getFullYear() &&
                currentYear <= new Date(milestone.max_end_date).getFullYear()) ||
              viewModeType == 'All' ||
              (currentYear >= new Date(milestone.min_start_date).getFullYear() &&
                currentYear <= new Date(milestone.max_end_date).getFullYear() &&
                viewModeType == 'Day' &&
                (currentMonth == new Date(milestone.min_start_date).getMonth() + 1 ||
                  currentMonth == new Date(milestone.max_end_date).getMonth() + 1)) ||
              (Date.parse(currentMonthDate) <= Date.parse(milestone.max_end_date) &&
                Date.parse(currentMonthDate) >= Date.parse(milestone.min_start_date))
            ) {
              const t: Task = {
                start: new Date(milestone.min_start_date),
                end: new Date(milestone.max_end_date),
                name: milestone.major_milestone_name,
                id: milestone.milestone_reference,
                progress: Math.round(milestone.progress),
                type: 'project',
                hideChildren: false,
                styles: { progressColor: '#ffbb54', progressSelectedColor: '#ff9e0d' }
              };
              const minorData = makeTaskObj(milestone.minor_milestones);
              if (minorData.length > 0 && viewModeType == 'Day') {
                taskList = [...taskList, t];
              } else if (viewModeType !== 'Day') {
                taskList = [...taskList, t];
              }
              taskList = [...taskList, ...minorData];
              setTasks(taskList);
            } else {
              setTasks(taskList);
            }
          } else {
            setTasks(taskList);
          }

          dispatch(setProgress(false));
        });
      }
    } catch (error: any) {
      setTasks([]);
      // store.dispatch(setSnackbarMessage('Request Failed', 'error'));
      //dispatch(setMessage({ msgDetails: mileStoneLoadingErrorMsg, severity: 'error' }));
      if (error.response.status === 403) {
        //dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      }
    }
  };

  useEffect(() => {
    getMilestoneGanttViewData();
  }, [viewModeType, currentMonth, currentYear, search]);

  const handleExpanderClick = (task: Task) => {
    setTasks(tasks.map(t => (t.id === task.id ? task : t)));
  };

  return (
    <div className="gantt-view">
      {/* <ProgressBarComponent></ProgressBarComponent> */}
      {tasks.length > 0 ? (
        <Gantt
          tasks={tasks}
          viewMode={viewModeType === 'All' ? 'Month' : viewModeType}
          onExpanderClick={handleExpanderClick}
          columnWidth={columnWidth}
        />
      ) : (
        <div className="gantt-view-text">
          <h4>No Data Available</h4>
        </div>
      )}
    </div>
  );
};

export default memo(MilestoneGanttChart);
